import * as React from "react";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import CustomExistingTemplates from "./CustomExistingTemplates";
import { TabPanel, Tab, TabsList } from "../../../components/tabs/TabUnstyled";

export default function CustomTab() {
  const { t } = useTranslation();
  return (
    <>
      <div className="row">
        <TabsUnstyled defaultValue={1} sx={{ backgroundColor: "#fff" }}>
          <TabsList sx={{ maxWidth: "31rem" }}>
            <Tab>New Custom Questionnaire </Tab>
            <Tab>Existing Templates</Tab>
          </TabsList>
          <TabPanel value={0}></TabPanel>
          <TabPanel value={1}>
            <CustomExistingTemplates />
          </TabPanel>
        </TabsUnstyled>
      </div>
    </>
  );
}
